import { PanelSection, type PanelSectionProps } from '@dev-spendesk/grapes';
import cx from 'classnames';
import React from 'react';

type Props = PanelSectionProps & {
  isEmphasized?: boolean;
};

export function PanelTextSection({
  children,
  isEmphasized = false,
  ...panelSectionProps
}: Props) {
  return (
    <PanelSection {...panelSectionProps}>
      <div
        className={cx('text-content-primary body-m break-words', {
          'rounded-8 bg-background-secondary-default text-content-secondary-bg-secondary px-12 py-[10px]':
            isEmphasized,
        })}
      >
        {children}
      </div>
    </PanelSection>
  );
}
